"use strict";

Shopify.theme.jsFeaturedCollection = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if (this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }
    if (this.collection_style == 'slider' && isScreenSizeTablet()) {
      this.createSlider($section);
    }
  },
  createSlider: function createSlider($section) {
    var featuredCollectionSlider = $section.find('.collection-product-wrapper');
    let $left = $section.find('[data-icon-left]');
    let $right = $section.find('[data-icon-right]');
    let slider ;
    let _self = this
    var slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "center",
      wrapAround: false
    };
    slider = $(featuredCollectionSlider).flickity({
      draggable: true,
      cellAlign: slideData.cellAlign,
      wrapAround: slideData.wrapAround,
      pageDots: false,
      prevNextButtons: false,
      arrowShape: arrowShape,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $(featuredCollectionSlider).flickity('resize');
          }, 500);
        }
      }
    });
    $left.on('click',function(e){
      slider.flickity('previous');
      _self.updateContent($section)

    })
    $right.on('click',function(e){
      slider.flickity('next');
      _self.updateContent($section)
    })
  },
  updateContent: function updateContent($parent){
    let limit = this.products_limit
    let _self = this
    let currentIndex = $parent.find('.is-selected').data('index')+1
    if(currentIndex=='1'){
        $parent.find('[data-icon-left]').addClass('is-disabled')
    }else if(currentIndex == limit){
        $parent.find('[data-icon-right]').addClass('is-disabled')
    }else{
        $parent.find('[data-icon-right]').removeClass('is-disabled')
        $parent.find('[data-icon-left]').removeClass('is-disabled')
    }
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};